import gsap from 'gsap'
import Site from 'stores/Site'

export default class MobileNav {
    constructor(el) {
        this.el = el
        this.level = 0
        this.ids = [0, 0, 0]
        this.items = [
            this.el.querySelectorAll('.menu-item-depth-0'),
            this.el.querySelectorAll('.menu-item-depth-1'),
            this.el.querySelectorAll('.menu-item-depth-2')
        ]
        this.levelEls = this.el.querySelectorAll('.mobile-nav-level')
        this.backBtns = this.el.querySelectorAll('.btn-back')

        this.initMobileMenuToggle()
        this.initMobileMenuNav()
    }

    initMobileMenuToggle() {
        const toggle = document.querySelector('.mobile-nav-toggle')
        const bg = this.el.querySelector('.mobile-nav-bg')

        toggle.addEventListener('click', () => {
            this.toggleMenu()
        })

        bg.addEventListener('click', () => {
            this.toggleMenu()
        })
    }

    toggleMenu() {
        if (Site.html.classList.contains('nav-active')) {
            Site.html.classList.remove('nav-active')

            setTimeout(()=> {
                this.levelEls.forEach((el, i) => {
                    if (i > 0) {
                        el.classList.remove('active')
                    } else {
                        el.classList.add('active')
                    }
                })
            }, 200)
        } else {
            Site.html.classList.add('nav-active')
        }
    }

    handleNav() {
        this.levelEls.forEach((el, i) => {
            if (i === this.level) {
                el.classList.add('active')
            } else {
                el.classList.remove('active')
            }
        })

        this.ids.forEach((id, i) => {
            if (id > 0) {
                this.items[i].forEach(item => {
                    if (item.getAttribute('data-id') === id) {
                        item.classList.add('active')
                    } else {
                        item.classList.remove('active')
                    }
                })
            }
        })
    }

    initMobileMenuNav() {
        const parentItems = this.el.querySelectorAll('.menu-item-has-children > a')

        parentItems.forEach(item => {
            item.addEventListener('click', e => {
                e.preventDefault()

                const parent = item.parentNode
                const level = parseInt(parent.closest('.mobile-nav-level').getAttribute('data-level'))
                const text = item.textContent

                this.ids[level] = parent.getAttribute('data-id')

                this.level = level + 1

                if (this.level > 0 && this.level <= 2) {
                    this.backBtns[this.level].querySelector('.btn-text-inner').textContent = text
                }

                this.handleNav()
            })
        })

        this.backBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const level = btn.getAttribute('data-level')

                this.level = level - 1

                this.handleNav()
            })
        })
    }

    onResize() {
        if (Site.html.classList.contains('nav-active')) {
            Site.html.classList.remove('nav-active')
        }
    }

    onScroll(e) {

    }
}